import React, { Component } from 'react';

// Externals
import PropTypes from 'prop-types';

// Material helpers
import { withStyles } from '@material-ui/core/styles';

// Material components
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { Rating } from '@material-ui/lab';
import TextField from '@material-ui/core/TextField/index';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';

// Component styles
import styles from '../../styles';
import { Grid } from '@material-ui/core';
import { withTranslation } from 'react-i18next';
// Custom styles
import Filter from '../../../../../../helpers/Filter'
import {feedback} from '../../../../../../services/feedBack'
import { isNull } from 'underscore';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';

class FeedBack extends Component {

  
  constructor(props) {
    super(props);
    this.state = {
      value:5,
      ListFilter:[{"nombre":"sidebar.quickview","seccion":"mas útil"},{"nombre":"sidebar.operational_state","seccion":"mas útil"}, 
                  {"nombre":"sidebar.general_state","seccion":"mas útil"}, {"nombre":"sidebar.quickview_isp","seccion":"mas útil"}, 
                  {"nombre":"sidebar.quickview_isp","seccion":"mas útil"}, {"nombre":"sidebar.flashboard_visibility", "seccion":"mas útil"}, {"nombre": "sidebar.flashboard_visibility", "seccion":"mas útil"},
                  {"nombre": "sidebar.apdex", "seccion":"mas útil"}, {"nombre": "sidebar.compare_objectives", "seccion":"mas útil"},                  
                  {"nombre":"sidebar.configure_objectives","seccion":"mas útil"},
                  {"nombre":"sidebar.administration","seccion":"mas útil"}, {"nombre":"sidebar.maintenance","seccion":"mas útil"}],
      ListFilterImprovement:[{"nombre":"sidebar.operational_state","seccion":"mejora"},{"nombre":"sidebar.quickview","seccion":"mejora"}, 
                            {"nombre":"sidebar.general_state","seccion":"mejora"}, {"nombre":"sidebar.quickview_isp","seccion":"mejora"}, 
                            {"nombre":"sidebar.quickview_isp","seccion":"mejora"}, {"nombre":"sidebar.flashboard_visibility", "seccion":"mejora"}, {"nombre": "sidebar.flashboard_visibility", "seccion":"mejora"},
                            {"nombre": "sidebar.apdex", "seccion":"mejora"}, {"nombre": "sidebar.compare_objectives", "seccion":"mejora"}, 
                            {"nombre":"sidebar.configure_objectives","seccion":"mejora"},
                            {"nombre":"sidebar.administration","seccion":"mejora"}, {"nombre":"sidebar.maintenance","seccion":"mejora"}],

      defaultValue:{value:5,combo:{usefull:"sidebar.quickview", improvement:"sidebar.operational_state"}, desc:""},
      error:false,
      errorText:""
    };
  }

  componentDidMount(){
    const { t } = this.props;
    this.setState(prev=>({
      defaultValue: {
        ...prev.defaultValue,
        combo: {
          usefull: t(prev.defaultValue.combo.usefull),
          improvement: t(prev.defaultValue.combo.improvement)
        }
      }
    }))
  }


  ratingChange = (mode, event) => {
    const {defaultValue}=this.state
    if(isNull(event)){
      var errorText=""
      if(mode==="mas útil"){
        errorText=this.props.t('feedback.modal.error.select-useful')
      }
      if(mode==="mejora"){
        errorText=this.props.t('feedback.modal.error.select-improvement')
      }
      this.setState({
        error: true,
        errorText:errorText
      });
    }else{
      if(mode==="rating"){
        defaultValue["value"]=event
      }
      if(mode==="mas útil"){
        defaultValue["combo"]["usefull"]=event.nombre
      }
      if(mode==="mejora"){
        defaultValue["combo"]["improvement"]=event.nombre
      }
      if(mode==="comment"){
        defaultValue["desc"]=event
      }
      if(event.seccion==="mas útil"){
        defaultValue["util"]=event.nombre
      }
      if(event.seccion==="mejora"){
        defaultValue["mejora"]=event.nombre
      }
      if(defaultValue["combo"]["improvement"]===defaultValue["combo"]["usefull"]){
        this.setState({
          value: event,
          error: true,
          errorText:this.props.t('feedback.modal.error.select-distinct')
        });
      }else{
        this.setState({
          value: event, defaultValue:defaultValue,
          error: false,
          errorText:""
        });
      }
      
    }
    
  };


  handleSaved=()=>{
    const {defaultValue, error}=this.state
    const {combo}=defaultValue
    if(error===false){
      const removeAccents = (str) => {
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      } 
      var stars=defaultValue.value

      if (defaultValue.util === undefined) {
        var usefull=removeAccents(combo.usefull)
      }else{
        var usefull=removeAccents(defaultValue.util)
      }

      if (defaultValue.mejora === undefined) {
        var improvement= removeAccents(combo.improvement)
      }else{
        var improvement = removeAccents(defaultValue.mejora)
      }

      var desc=defaultValue.desc
      let token = sessionStorage.getItem('key')
      let user = sessionStorage.getItem('user')
      feedback(user, stars, usefull, improvement, desc, token).then(data=>{
        if(data.estado===true){
          this.setState({
            modal: true,
            errorModal:false,
          });
        }else{
          this.setState({
            modal: true,
            errorModal:true
          });
        }
      })
      setTimeout(() => {this.props.handleCloseFeedback()},2500)
      setTimeout(() => {this.handleCloseFeedbackModal()},2500)
      
    }
  }
  handleCloseFeedbackModal = () => {
    this.setState({ modal: false });
  };


  handleClose = event => {
    this.props.handleCloseFeedback()
  };

  render() {
    const {value, ListFilter, ListFilterImprovement, error, errorText, modal, errorModal}=this.state
    const {classes, t}=this.props
    return (

        <Grid container spacing={2} className={classes.FeedBack} style={{padding: "15px"}}>
          <Grid
            item
            sm={4}
            xl={4}
            xs={4}
            md={4}>
            <img
              alt="Atentus logo"
              src="/images/logos/logo-atentus-azul.svg"
              height="40px"
            />
          </Grid>
          <Grid
            item
            sm={8}
            xl={8}
            xs={8}
            md={8}
            style={{color:"black", textAlign: 'right'}}>
            <IconButton 
              key="close" 
              aria-label="close" 
              style={{color:"black"}}
              onClick={this.handleClose}>
              <CloseIcon/>
            </IconButton>
          </Grid>
          <Grid
            item
            sm={12}
            xl={12}
            xs={12}
            md={12}>
        <Typography>{t('feedback.modal.text.rate')}</Typography>
          </Grid>
          <Grid
            item
            sm={12}
            xl={12}
            xs={12}
            md={12}
            className={classes.centerText}>
            <Rating
              max={5}
              name="simple-controlled"
              value={value}
              onChange={(value, newValue) => {
                this.ratingChange('rating', newValue);
              }}
            />
          </Grid>
          <Grid
            item
            sm={12}
            xl={12}
            xs={12}
            md={12}
          >
        <Typography>{t('feedback.modal.text.useful-component')}</Typography>
          </Grid>
          <Grid
            item
            sm={12}
            xl={12}
            xs={12}
            md={12}
            className={classes.centerText}>
              <Filter InfoAutoComplete={this.ratingChange} list={ListFilter.map(item => ({...item, nombre: t(item.nombre)}))}/>
          </Grid>
          <Grid
            item
            sm={12}
            xl={12}
            xs={12}
            md={12}
          >
        <Typography>{t('feedback.modal.text.comments')}</Typography>
          </Grid>
          <Grid
            item
            sm={12}
            xl={12}
            xs={12}
            md={12}
            className={classes.centerText}>
              <Filter InfoAutoComplete={this.ratingChange} list={ListFilterImprovement.map(item => ({...item, nombre: t(item.nombre)}))}/>
          </Grid>
          <Grid
            item
            sm={12}
            xl={12}
            xs={12}
            md={12}
            className={classes.centerText}>
        <Typography>{t('feedback.modal.text.comments')}</Typography>
          </Grid>
          <Grid
            item
            sm={12}
            xl={12}
            xs={12}
            md={12}
            className={classes.centerText}>
              <TextField
                id="standard-multiline-static"
                label=""
                onChange={event =>
                    this.ratingChange('comment', event.target.value)
                }
                multiline
                required
                rows={6}
                defaultValue=""
                helperText={`${this.state.defaultValue.desc.length}/500`}
                variant='outlined'
                inputProps={{ maxLength: 500 }}
                fullWidth
              />
          </Grid>
          <Grid
            item
            sm={12}
            xl={12}
            xs={12}
            md={12}
            className={classes.centerText}>
        <Typography>{t('feedback.modal.placeholder.your-opinion')}</Typography>
          </Grid>
          {error===true?
          <Grid
            item
            sm={12}
            xl={12}
            xs={12}
            md={12}
            className={classes.centerText}>
              <Typography style={{color:"#c62828"}}>{errorText}</Typography>
          </Grid>:null}
          <Grid
            item
            sm={12}
            xl={12}
            xs={12}
            md={12}
            className={classes.centerText}>
              <Button
                color="primary"
                variant="contained"
                onClick={this.handleSaved}
              >
                {t('feedback.modal.button.title')}
              </Button>
          </Grid>
          <Modal
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            open={modal}
            onClose={this.handleCloseFeedbackModal}
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
            disableAutoFocus={true}
            disableEnforceFocus={true}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >                                    
          <Fade in={modal}>
            <Grid container spacing={4} className={classes.FeedBackSaveBack} >
              {errorModal===true?
                <Grid
                  item
                  sm={12}
                  xl={12}
                  xs={12}
                  md={12}
                  className={classes.centerText}>
                    <Typography variant="h3" style={{color:"#c62828"}} >{this.props.t('feedback.modal.save_error')}</Typography>
                </Grid>:
                <Grid
                  item
                  sm={12}
                  xl={12}
                  xs={12}
                  md={12}
                  className={[classes.FeedBackSaveBack, classes.centerText]}
                  >
                    <Typography variant="h3" style={{color:"#388e3c"}}>{this.props.t('feedback.modal.save_success')}</Typography>
                </Grid>
              }
              
            </Grid>
          </Fade>
        </Modal>
      </Grid>
        
    );
  }
}

FeedBack.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  notifications: PropTypes.array.isRequired,
  onSelect: PropTypes.func
};

FeedBack.defaultProps = {
  notifications: [],
  onSelect: () => {}
};

export default withTranslation()(withStyles(styles)(FeedBack));

